// Import jQuery => utilise celui de wp de base, evite duplicat de jquery
// import jQuery from "../../gulp/node_modules/jquery";
// export for others scripts to use
window.$ = window.jQuery = jQuery;

// Is user logged in
window.user_logged_in = document.body.classList.contains('logged-in');

// Theme path
//const resourcesPath = "/app/themes/sooyoos/resources/public"

// Vendors
import './plugins/prism';

// Require modules
import browsetClassHelpers from './modules/browser-class-helpers.js'
import header from './modules/header.js'
import footer from './modules/footer.js'
import photoGallery from './modules/photoGallery.js'
import type_it from './modules/type_it'
import popin from './modules/popin.js'
import testimoniesSlider from './modules/testimoniesSlider.js'
import textImageSlider from './modules/textImageSlider.js'
import navScrollHighlight from './modules/nav-scroll-highlight.js'
import chapter from './modules/chapter.js'
import form from './modules/form.js'
import contactModal from './modules/contactModal.js'
import offer from './modules/offer.js'
import references from './modules/references'
import keyFigures from './modules/keyFigures'
import Logos from './modules/logos'
import publications from './modules/publications'
import formList from './modules/formList'
import video from './modules/video'
import globalAnimation from './modules/globalAnimation'
import scrollAnimations from './modules/scrollAnimations'
import flowFileDl from './modules/flow-file-dl'
import ajaxNav from './modules/ajaxNav'
import lpbTestimoniesSlider from './modules/lpbTestimoniesSlider'
//import pageLoader from './modules/pageLoader';

if (!window.user_logged_in) {
	ajaxNav.init();
}

window.init_module_for_new_page = function() {
	footer.init();
	globalAnimation.init();
	scrollAnimations.init();
	if (!window.user_logged_in) {
		ajaxNav.bindEvents();
	}

	if ($(".js-form-input").length) {
		form.trigger_toggleHasValueClass();
	}

	if (document.querySelectorAll('.js-contactModal-selectForm').length > 0) {
		contactModal.bindEvents_selectForm();
	}

	if (document.querySelectorAll('.js-photoGallerySlider').length > 0) {
		photoGallery.init();
	}

	if (document.querySelectorAll('.js-lpbTestimoniesSlider').length > 0) {
		lpbTestimoniesSlider.init();
	}

	if ($(".js-flow-file-dl").length) {
		flowFileDl.init();
	}

	if ($(".js-type-it").length) {
		type_it.init();
	}

	if ($(".js-popin").length) {
		popin.init();
	}

	if ($(".js-testimoniesSlider").length) {
		testimoniesSlider.init();
	}

	if ($(".js-textImageSlider").length) {
		textImageSlider.init();
	}

	if ($(".js-nav-link").length) {
		navScrollHighlight.init();
	}

	if ($(".js-chapter").length) {
		chapter.init();
	}

	if ($(".js-offer-slider-mobile").length) {
		offer.init();
	}

	if ($(".js-refcardlist-slider").length) {
		references.init();
	}

	if ($(".js-keyfigures-slider").length) {
		keyFigures.init();
	}

	if ($(".js-logos-slider").length) {
		Logos.init();
	}

	if ($(".js-blogcard-list-mobile").length) {
		publications.init();
	}

	if ($(".js-formlist-slider").length) {
		formList.init();
	}

	if ($(".js-video").length) {
		video.init();
	}
}

$(function(){
	// Everything here must be loading only once
	$("html").removeClass("no-js");

	browsetClassHelpers.init();
	header.init();
	//pageLoader.init();

	if ($(".js-gravity-form").length) {
		form.init();
	}

	if ($(".js-contactModal").length) {
		contactModal.init();
	}

	// Everything inside this function must be loaded each time we load a new page with ajax
	window.init_module_for_new_page();
});

